import { styled, Switch, SwitchProps } from "@mui/material";
import {
	NeutralColor,
	PrimaryColor,
	SecondaryColor,
} from "node-library/dist/colors";

const LargeSwitch = styled((props: SwitchProps) => (
	<Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
	width: 110,
	height: 38,
	borderRadius: 25,
	border: `1px solid ${NeutralColor.NEUTRAL_GREY_950}`,
	padding: 0,
	"& .MuiSwitch-switchBase": {
		padding: 3,
		margin: 0,
		transitionDuration: "300ms",
		width: "50%",
		height: "100%",
		color: NeutralColor.NEUTRAL_GREY_950,
		"&.Mui-checked": {
			transform: "translateX(55px)",
			color: PrimaryColor.PRIMARY_LV5,
			"& + .MuiSwitch-track": {
				backgroundColor: "transparent",
				opacity: 1,
				border: 0,
			},
			"&.Mui-disabled + .MuiSwitch-track": {
				opacity: 0.5,
			},
		},

		"&.Mui-disabled + .MuiSwitch-track": {
			opacity: 0.7,
		},
	},
	"& .MuiSwitch-thumb": {
		boxSizing: "border-box",
		width: "100%",
		height: "100%",
		borderRadius: 25,
	},
	"& .MuiSwitch-track": {
		backgroundColor: "transparent",
		opacity: 1,
	},
}));

const CustomSwitch = styled((props: SwitchProps) => (
	<Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
	width: 54,
	height: 30,
	borderRadius: 25,
	border: `1px solid ${NeutralColor.NEUTRAL_GREY_950}`,
	padding: 0,
	"& .MuiSwitch-switchBase": {
		padding: 3,
		margin: 0,
		transitionDuration: "300ms",
		width: "50%",
		height: "100%",
		color: NeutralColor.NEUTRAL_GREY_950,
		"&.Mui-checked": {
			transform: "translateX(26px)",
			color: PrimaryColor.PRIMARY_LV5,
			"& + .MuiSwitch-track": {
				backgroundColor: "transparent",
				opacity: 1,
				border: 0,
			},
			"&:hover + .MuiSwitch-track": {
				backgroundColor: PrimaryColor.PRIMARY_50,
			},
			"&.Mui-disabled + .MuiSwitch-track": {
				opacity: 0.5,
			},
		},
		"&.Mui-disabled + .MuiSwitch-track": {
			opacity: 0.7,
		},
	},
	"& .MuiSwitch-thumb": {
		boxSizing: "border-box",

		borderRadius: "50%",
	},
	"& .MuiSwitch-track": {
		backgroundColor: "transparent",
		opacity: 1,
		transition: "background-color 300ms",
	},
	"&:hover .MuiSwitch-track": {
		backgroundColor: PrimaryColor.PRIMARY_50,
	},
}));

export { LargeSwitch, CustomSwitch };
